import { render } from "./GammeAccessori.vue?vue&type=template&id=ebaa7354"
import script from "./GammeAccessori.vue?vue&type=script&lang=js"
export * from "./GammeAccessori.vue?vue&type=script&lang=js"

import "./GammeAccessori.vue?vue&type=style&index=0&id=ebaa7354&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__